<div class="action-icons-container material-icons-outlined">
  @if (canMove) {
  <span
    id="action-move-order"
    class="action-icons move-icon"
    matTooltipPosition="below"
    matTooltip="Move order to selected alert"
    (click)="onMoveOrder($event)"
    >drive_file_move</span
  >
  } @if (!isSystemGenerated) {
  <span
    id="action-copy-order"
    class="action-icons copy-icon"
    matTooltipPosition="below"
    matTooltip="Copy order to selected alert"
    (click)="onCopyOrder($event)"
    >copy_all</span
  >
  } @if (canDelete) {
  <span
    id="action-remove-order"
    class="action-icons remove-icon"
    matTooltipPosition="below"
    matTooltip="Remove watch order"
    (click)="removeWatchOrder()"
    >remove_circle_outline</span
  >
  }
</div>
